import type { DreamJob } from '../services/api'

/**
 * MWA-310 — the answers a search partner wants before they will read on.
 *
 * Dee, [26:24]: "Joe Blow, who's head of finding CFOs for companies, he wants
 * to know what city are you in? What's your compensation range? You know, are
 * you willing to relocate?"
 *
 * Those three are the only questions she named. She said the letter answers
 * "like eight", but never listed the rest, so the remainder live as talking
 * points on the template where an admin can add them without a code change.
 *
 * Anything unanswered comes back EMPTY rather than filled with a plausible
 * guess: the composer's empty-field warning is what turns a gap into a prompt
 * before the intro goes out.
 */
export function searchPartnerMergeValues(dreamJob?: DreamJob): Record<string, string> {
  const locations = dreamJob?.locationPreferences ?? []
  const target = dreamJob?.salaryTarget?.trim() || ''
  const minimum = dreamJob?.salaryMinimum?.trim() || ''

  return {
    clientCity: locations.filter(Boolean).join(', '),
    compensationRange: formatRange(minimum, target),
    // A "no" is an answer. Only an unset willingness is a gap, and the field is
    // a plain boolean, so undefined is the only way to express that.
    relocation:
      dreamJob?.willingToRelocate === undefined
        ? ''
        : dreamJob.willingToRelocate
          ? 'open to relocating'
          : 'not open to relocating',
    targetTitles: dreamJob?.targetRole?.trim() || '',
    industries: dreamJob?.targetIndustry?.trim() || '',
  }
}

/** A range needs both ends; one end still answers the question, so say which. */
function formatRange(minimum: string, target: string): string {
  if (minimum && target) return `${minimum} - ${target}`
  if (minimum) return `from ${minimum}`
  if (target) return `up to ${target}`
  return ''
}
